import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { LoadingSpinner } from './LoadingSpinner';

interface ProtectedTestRouteProps {
  children: React.ReactNode;
}

export const ProtectedTestRoute: React.FC<ProtectedTestRouteProps> = ({ children }) => {
  const { user, loading } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const { testId } = useParams();

  useEffect(() => {
    if (!loading && !user) {
      // Store the current path for redirect after signin
      sessionStorage.setItem('redirectPath', location.pathname + location.search);
      navigate('/signin');
    }
  }, [user, loading, navigate, location]);

  if (loading) {
    return <LoadingSpinner message="Checking authentication..." fullScreen />;
  }

  if (!user) {
    return null; // Will redirect in useEffect
  }

  return <>{children}</>;
};